import * as React from "react";
import type { SVGProps } from "react";
const SvgFileUp02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.8 21.6H6a2.4 2.4 0 0 1-2.4-2.4V4.8A2.4 2.4 0 0 1 6 2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v6.6m-3.6 6.643 2.454-2.443m0 0 2.346 2.332M18.054 15.6v6M7.8 7.2H15m-7.2 3.6H15m-7.2 3.6h3.6"
    />
  </svg>
);
export default SvgFileUp02;
